const HORIZONTAL = 'horizontal';
const VERTICAL = 'vertical';

export const SCREEN_WIDTHS = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
};

const getLayoutFromWindowSizeAndNumberOfCards = (
  width: number,
  noOfPlans: number
) => {
  if (width >= SCREEN_WIDTHS.MD && width < SCREEN_WIDTHS.LG && noOfPlans <= 3) {
    return HORIZONTAL;
  } else if (
    width >= SCREEN_WIDTHS.LG &&
    width < SCREEN_WIDTHS.XL &&
    noOfPlans <= 4
  ) {
    return HORIZONTAL;
  } else if (width >= SCREEN_WIDTHS.XL) {
    return HORIZONTAL;
  } else {
    return VERTICAL;
  }
};

export const isCardsVertical = (width: number, noOfPlans: number) => {
  return getLayoutFromWindowSizeAndNumberOfCards(width, noOfPlans) === VERTICAL;
};
